"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const asDate = require("./asDate.cjs");
const asLink = require("./asLink.cjs");
const asText = require("./asText.cjs");
const asHTML = require("./asHTML.cjs");
const asImageSrc = require("./asImageSrc.cjs");
const asImageWidthSrcSet = require("./asImageWidthSrcSet.cjs");
const asImagePixelDensitySrcSet = require("./asImagePixelDensitySrcSet.cjs");
const isFilled = require("./isFilled.cjs");
const documentToLinkField = require("./documentToLinkField.cjs");
const richtext = require("@prismicio/richtext");
const Elements = richtext.Element;
exports.asDate = asDate.asDate;
exports.asLink = asLink.asLink;
exports.asText = asText.asText;
exports.asHTML = asHTML.asHTML;
exports.asImageSrc = asImageSrc.asImageSrc;
exports.asImageWidthSrcSet = asImageWidthSrcSet.asImageWidthSrcSet;
exports.asImagePixelDensitySrcSet = asImagePixelDensitySrcSet.asImagePixelDensitySrcSet;
exports.isFilled = isFilled;
exports.documentToLinkField = documentToLinkField.documentToLinkField;
Object.defineProperty(exports, "Element", {
  enumerable: true,
  get: () => richtext.Element
});
exports.Elements = Elements;
//# sourceMappingURL=index.cjs.map
